import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'
/**
 * @implements UseCase
 */
export class SaveNavigationDataAdsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.fromPlaceholderUrlToNextPageUrl
   * @param {Object} deps.fromPlaceholderUrlToPreviousPageUrl
   * @param {Object} deps.navigationDataRequestValueObjectFactory
   * @param {Object} deps.saveNavigationDataAdsService
   */
  constructor({
    config,
    fromPlaceholderUrlToNextPageUrl,
    fromPlaceholderUrlToPreviousPageUrl,
    navigationDataRequestValueObjectFactory,
    saveNavigationDataAdsService
  }) {
    super()

    this._config = config
    this._fromPlaceholderUrlToNextPageUrl = fromPlaceholderUrlToNextPageUrl
    this._fromPlaceholderUrlToPreviousPageUrl = fromPlaceholderUrlToPreviousPageUrl
    this._navigationDataRequestValueObjectFactory = navigationDataRequestValueObjectFactory
    this._service = saveNavigationDataAdsService
  }

  /**
   * @return {Promise<Object, Error>} list of searches
   */
  @inlineError
  async execute({ads, currentPage, placeholder, placeholderUrl, searchUrl, totalPages, totalResults}) {
    const nextPageUrl = this._fromPlaceholderUrlToNextPageUrl.map({
      currentPage,
      placeholder,
      totalPages,
      url: placeholderUrl
    })
    const prevPageUrl = this._fromPlaceholderUrlToPreviousPageUrl.map({
      currentPage,
      placeholder,
      url: placeholderUrl
    })
    const NAVIGATION_TYPES = this._config.get('NAVIGATION_TYPES')
    const navigationDataRequestValueObject = this._navigationDataRequestValueObjectFactory({
      nextPageUrl,
      prevPageUrl,
      searchUrl,
      items: ads,
      type: NAVIGATION_TYPES.ADS,
      totalResults,
      currentPage
    })
    return this._service
      .execute(navigationDataRequestValueObject)
      .then(([saveNavigationDataError, saveNavigationDataResponse]) => {
        if (saveNavigationDataError) return Promise.reject(saveNavigationDataError)
        return saveNavigationDataResponse
      })
  }
}
